import { BooleanField } from '@src/permitField/PermitFields';
import * as TrailerDimensionPermitField from '@src/permitField/TrailerDimensionFields';
import * as TrailerInformationPermitField from '@src/permitField/TrailerInformationFields';

export class TrailerUnitNumberField extends BooleanField {
  public static fieldName: string =
    TrailerInformationPermitField.TrailerUnitNumberField.fieldName;
}

export class TrailerYearField extends BooleanField {
  public static fieldName: string =
    TrailerInformationPermitField.TrailerYearField.fieldName;
}

export class TrailerTypeField extends BooleanField {
  public static fieldName: string =
    TrailerInformationPermitField.TrailerTypeField.fieldName;
}

export class TrailerMakeField extends BooleanField {
  public static fieldName: string =
    TrailerInformationPermitField.TrailerMakeField.fieldName;
}

export class TrailerVINField extends BooleanField {
  public static fieldName: string =
    TrailerInformationPermitField.TrailerVINField.fieldName;
}

export class TrailerLicensePlateField extends BooleanField {
  public static fieldName: string =
    TrailerInformationPermitField.TrailerLicensePlateField.fieldName;
}

export class TrailerLicensePlateStateField extends BooleanField {
  public static fieldName: string =
    TrailerInformationPermitField.TrailerLicensePlateStateField.fieldName;
}

export class TrailerLicensePlateTypeField extends BooleanField {
  public static fieldName: string =
    TrailerInformationPermitField.TrailerLicensePlateTypeField.fieldName;
}

export class TrailerAxleCountField extends BooleanField {
  public static fieldName: string =
    TrailerInformationPermitField.TrailerAxleCountField.fieldName;
}

export class TrailerLengthField extends BooleanField {
  public static fieldName: string =
    TrailerDimensionPermitField.TrailerLengthField.fieldName;
}

export class TrailerWidthField extends BooleanField {
  public static fieldName: string =
    TrailerDimensionPermitField.TrailerWidthField.fieldName;
}

export class TrailerHeightField extends BooleanField {
  public static fieldName: string =
    TrailerDimensionPermitField.TrailerHeightField.fieldName;
}

export class TrailerWheelbaseField extends BooleanField {
  public static fieldName: string =
    TrailerDimensionPermitField.TrailerWheelbaseLengthField.fieldName;
}

export class TrailerDeckHeightField extends BooleanField {
  public static fieldName: string =
    TrailerDimensionPermitField.TrailerDeckHeightField.fieldName;
}

export class TrailerGroundClearanceField extends BooleanField {
  public static fieldName: string =
    TrailerDimensionPermitField.TrailerGroundClearanceField.fieldName;
}

export class TrailerKingPinSetbackLengthField extends BooleanField {
  public static fieldName: string =
    TrailerDimensionPermitField.TrailerKingpinSetbackLengthField.fieldName;
}

export class TrailerKingPinSettingLengthField extends BooleanField {
  public static fieldName: string =
    TrailerDimensionPermitField.TrailerKingpinSettingLengthField.fieldName;
}

export class TrailerEmptyWeightField extends BooleanField {
  public static fieldName: string =
    TrailerDimensionPermitField.TrailerEmptyWeightField.fieldName;
}

export class TrailerRegisteredWeightField extends BooleanField {
  public static fieldName: string =
    TrailerDimensionPermitField.TrailerRegisteredWeightField.fieldName;
}

export class IsDualLaneField extends BooleanField {
  public static fieldName: string =
    TrailerInformationPermitField.IsDualLaneField.fieldName;
}

export class IsTrunnionAxleField extends BooleanField {
  public static fieldName: string =
    TrailerInformationPermitField.IsTrunnionAxleField.fieldName;
}
